<div class="container-fluid ecommerce-landing">

    <p class="landing-subtitle">
        One quick verification and your account is live for accepting payments. You can connect your store in sandbox
        mode in the meantime. </p>

    <div class="progress-banner">
        <strong>{{ bannerCopy.heading }} - </strong>{{ bannerCopy.message }}
    </div>

    <div class="row verification-cards">
        <div class="col-md-6">
            <app-verification-card
                (actionClick)="onKycCardAction()"
                (secondaryActionClick)="regenerateKycLink()"
                [actionLabel]="kycCardActionLabel"
                [secondaryActionLabel]="kycCardSecondaryActionLabel"
                [secondaryActionDisabled]="regeneratingKycLink"
                [cardState]="kycCardState"
                description="Know-Your-Customer checks confirm your business identity. We verify your registration, director details and address on file."
                footerNote="Takes ~5 minutes"
                iconAccent="primary"
                iconClass="fas fa-shield-halved"
                title="KYC Verification">
                <p class="verification-card-guidance" failed-guidance>
                    Your details couldn't be verified. Please update your information in
                    <a class="verification-card-link" [routerLink]="accountSettingsPath">Account Settings</a>.
                </p>
            </app-verification-card>
        </div>
        <div class="col-md-6">
            <app-verification-card [cardState]="avsCardState"
                                   description="Account Verification Services confirm the bank account we'll settle your funds into. This runs automatically as part of your KYC submission, so you don't need to start it separately."
                                   footerNote="Runs with your KYC submission"
                                   iconAccent="accent"
                                   iconClass="fas fa-university"
                                   title="AVS Verification">
                <p class="verification-card-guidance" failed-guidance>
                    We couldn't verify your bank account. Please update your banking details in
                    <a class="verification-card-link" [routerLink]="accountSettingsPath">Account Settings</a>.
                </p>
            </app-verification-card>
        </div>
    </div>

    <div class="card store-section">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-8">
                    <div class="store-section-header">
                        <h2 class="store-section-title">Connect Your E-Commerce Store</h2>
                        <span class="status-chip sandbox-mode">Sandbox Mode</span>
                    </div>
                    <p class="store-section-description">
                        Setup and test your store in sandbox mode, then add your live keys and switch to production.
                        Our setup guide takes you through each step.
                    </p>
                    <a [href]="setupGuideLink"
                       class="setup-guide-button"
                       rel="noopener noreferrer"
                       target="_blank">View setup guide</a>
                </div>
                <div class="col-lg-4">
                    <div class="merchant-id-panel">
                        <div class="merchant-id-details">
                            <span class="merchant-id-label">External Identifier</span>
                            @if (businessDetailsLoadFailed) {
                                <span class="merchant-id-value">Unavailable</span>
                                <span class="merchant-id-hint">
                                    We couldn't load your external identifier. Please refresh the page to try again.
                                </span>
                            } @else {
                                <span class="merchant-id-value">{{ externalIdentifier }}</span>
                                <span class="merchant-id-hint">
                                    Paste this into your store's Pay@ Gateway settings to link
                                    your store to this account.
                                </span>
                            }
                        </div>
                        <button (click)="copyToClipboard(externalIdentifier, 'externalIdentifier')"
                                [disabled]="!externalIdentifier"
                                class="btn copy-btn"
                                type="button">
                            <i class="far fa-copy"></i> {{ copiedFields['externalIdentifier'] ? 'Copied' : 'Copy' }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <ngx-ui-loader></ngx-ui-loader>
</div>
